export default {"src":"/_next/static/media/layer.9be1b794.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};